import axios from "axios";
import process from "process";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CountryFlag from "../../components/CountryFlag";
import Translations from "../../components/MultiLanguage";
import Languages from "../../components/languages";

if (process.env.NODE_ENV === "development") {
  axios.defaults.baseURL = "http://localhost:5000";
} else if (window.location.hostname === "localhost") {
  axios.defaults.baseURL = "http://localhost:5000";
}
function VerifyEmail() {
  const navigateTo = useNavigate();
  const location = useLocation();

  // Parse the query parameters
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const email = queryParams.get("email");
  const [isEmpfehlio, setEmpfehlio] = useState(false);
  const [supportMail, setSupportMail] = useState("hello@truzzer.com");
  const [selected, setSelected] = useState(Languages[1]);
  const [languageMenu, setLanguageMenu] = useState(false);
  const [phrases, setPhrases] = useState(Translations[selected.locale]);
  const [successMessageEmail, setSuccessMessageEmail] = useState("");
  const handleLanguageChange = (selectedLocale) => {
    setSelected(selectedLocale);
    setLanguageMenu(false);
    setPhrases(Translations[selectedLocale.locale]);
  };
  useEffect(() => {
    if (window.location.hostname === "empfehlio.ekomiapps.de") {
      setEmpfehlio(true);
      setSupportMail("info@empfehlio.de");
    }
  }, []);

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const response = await axios.post(
          "/api/verify-email",
          { token: token, email: email },
          { headers: { "X-Custom-Origin": "https://truzzer.com/" } }
        );
        return response;
      } catch (error) {
        console.error("Failed to verify email", error);
      }
    };
    const runVerification = async () => {
      if (token && email) {
        const response = await verifyEmail();
        if (response.status === 200) {
          setSuccessMessageEmail(phrases.SuccessMessageVerifyEmail);
        } else {
          navigateTo("/error-page", { state: { status: 600 } });
        }
      }
    };
    runVerification();
  }, [token, email]);

  useEffect(() => {
    setPhrases(Translations[selected.locale]);
  }, [selected.locale]);

  return (
    <div className="flex items-center min-h-screen">
      {!isEmpfehlio && (
        <span className="absolute top-1 left-1 cursor-pointer text-white z-50">
          <div className="relative">
            <button
              onClick={() => setLanguageMenu(!languageMenu)}
              className="relative w-full cursor-default rounded-md pr-10 text-left text-gray-900 sm:text-sm sm:leading-6"
            >
              <span className="flex items-center">
                <CountryFlag countryCode={selected.countryCode} />
                <span className="ml-3 block truncate text-gray-900">
                  {selected.country}
                </span>
              </span>
            </button>

            {languageMenu && (
              <div className="absolute z-50 mt-1 max-h-64 w-full overflow-auto rounded-md bg-white py-1 text-black shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                {Languages.slice(1).map((language) => (
                  <div
                    key={language.id}
                    onClick={() => handleLanguageChange(language)}
                    className="cursor-default select-none relative p-2"
                  >
                    <div className="flex items-center">
                      <CountryFlag countryCode={language.countryCode} />
                      <span className="ml-3 block truncate">
                        {language.country}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </span>
      )}

      <div className="flex-1 flex-col justify-center px-6 py-12 lg:px-8 justify-items-center">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          <h1 className="mt-10 text-center text-4xl font-bold leading-9 tracking-tight text-gray-900">
            {phrases.VerifyTitle}
          </h1>
          <p className="mt-6 text-center text-lg leading-7 text-gray-600">
            {successMessageEmail}
          </p>
          <div className="mt-10 flex justify-center">
            <a
              href={`mailto:${supportMail}`}
              className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-500"
            >
              {phrases.VerifyEmail}
            </a>
          </div>
          <div className="mt-10 flex justify-center">
            <button
              onClick={() => navigateTo("/login")}
              className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-500"
            >
              {phrases.GoLoginPage}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VerifyEmail;
